<template>
  <div class="section_footer">
    <div class="item__footer">
      <div class="box_logo__footer">
        <div>
          <LogoToFooter class="logo_f" />
        </div>
        <div class="info_pages info_pages_desc">
          <router-link to="/terms-and-conditions" class="text_m"
            >Terms & Conditions</router-link
          >
          <router-link to="/privacy-policy" class="text_m"
            >Privacy Policy</router-link
          >
        </div>
      </div>
    </div>
    <div class="item__footer item__footer_res">
      <div class="item__footer_btn are_venue">
        <div class="text_footer">Are you a venue?</div>
        <router-link to="/partner" class="btn_white"
          >Become a partner</router-link
        >
      </div>
      <div class="item__footer_btn box_any_questions">
        <div class="text_footer">Any questions? Get in touch!</div>
        <router-link to="/contact-us" class="btn_white">Contact us</router-link>
      </div>
    </div>
    <div class="item__footer">
      <div class="box__follow-us-on">
        <div class="follow-us-on">Follow us on</div>
        <div class="icons_social">
          <a
            target="_blank"
            href="https://www.facebook.com/share/42JhJeZAP1eTjE75/?mibextid=LQQJ4d"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.3327 14.0672C27.3327 6.70722 21.3593 0.733887 13.9993 0.733887C6.63935 0.733887 0.666016 6.70722 0.666016 14.0672C0.666016 20.5206 5.25268 25.8939 11.3327 27.1339V18.0672H8.66602V14.0672H11.3327V10.7339C11.3327 8.16055 13.426 6.06722 15.9993 6.06722H19.3327V10.0672H16.666C15.9327 10.0672 15.3327 10.6672 15.3327 11.4006V14.0672H19.3327V18.0672H15.3327V27.3339C22.066 26.6672 27.3327 20.9872 27.3327 14.0672Z"
                fill="#FAFAFA"
              />
            </svg>
          </a>
          <a target="_blank" href="http://www.instagram.com/nightlife_card">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.9993 27.4001C21.3631 27.4001 27.3327 21.4305 27.3327 14.0667C27.3327 6.70293 21.3631 0.733398 13.9993 0.733398C6.63555 0.733398 0.666016 6.70293 0.666016 14.0667C0.666016 21.4305 6.63555 27.4001 13.9993 27.4001ZM17.7795 5.06689H10.2195C8.83508 5.06689 7.50735 5.61686 6.52841 6.5958C5.54947 7.57474 4.99951 8.90246 4.99951 10.2869V17.8469C4.99951 20.7269 7.33951 23.0669 10.2195 23.0669H17.7795C19.1639 23.0669 20.4917 22.5169 21.4706 21.538C22.4495 20.5591 22.9995 19.2313 22.9995 17.8469V10.2869C22.9995 7.40689 20.6595 5.06689 17.7795 5.06689ZM7.74849 7.81587C8.3561 7.20825 9.18021 6.86689 10.0395 6.86689H17.9595C19.7505 6.86689 21.1995 8.31589 21.1995 10.1069V18.0269C21.1995 18.8862 20.8582 19.7103 20.2505 20.3179C19.6429 20.9255 18.8188 21.2669 17.9595 21.2669H10.0395C8.24851 21.2669 6.79951 19.8179 6.79951 18.0269V10.1069C6.79951 9.24759 7.14087 8.42349 7.74849 7.81587ZM19.52 8.5464C19.309 8.33542 19.0229 8.21689 18.7245 8.21689C18.4261 8.21689 18.14 8.33542 17.929 8.5464C17.718 8.75738 17.5995 9.04353 17.5995 9.34189C17.5995 9.64026 17.718 9.92641 17.929 10.1374C18.14 10.3484 18.4261 10.4669 18.7245 10.4669C19.0229 10.4669 19.309 10.3484 19.52 10.1374C19.731 9.92641 19.8495 9.64026 19.8495 9.34189C19.8495 9.04353 19.731 8.75738 19.52 8.5464ZM17.1815 10.8849C16.3376 10.041 15.193 9.56689 13.9995 9.56689C12.806 9.56689 11.6614 10.041 10.8175 10.8849C9.97362 11.7288 9.49951 12.8734 9.49951 14.0669C9.49951 15.2604 9.97362 16.405 10.8175 17.2489C11.6614 18.0928 12.806 18.5669 13.9995 18.5669C15.193 18.5669 16.3376 18.0928 17.1815 17.2489C18.0254 16.405 18.4995 15.2604 18.4995 14.0669C18.4995 12.8734 18.0254 11.7288 17.1815 10.8849ZM12.0903 12.1577C12.5967 11.6514 13.2834 11.3669 13.9995 11.3669C14.7156 11.3669 15.4024 11.6514 15.9087 12.1577C16.415 12.6641 16.6995 13.3508 16.6995 14.0669C16.6995 14.783 16.415 15.4697 15.9087 15.9761C15.4024 16.4824 14.7156 16.7669 13.9995 16.7669C13.2834 16.7669 12.5967 16.4824 12.0903 15.9761C11.584 15.4697 11.2995 14.783 11.2995 14.0669C11.2995 13.3508 11.584 12.6641 12.0903 12.1577Z"
                fill="#FAFAFA"
              />
            </svg>
          </a>
          <a target="_blank" href="https://www.tiktok.com/@thenightlifecard">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.0003 0.733887C11.3632 0.733887 8.78538 1.51587 6.59273 2.98096C4.40007 4.44604 2.69111 6.52843 1.68194 8.96477C0.672769 11.4011 0.408725 14.082 0.923194 16.6684C1.43766 19.2548 2.70754 21.6306 4.57224 23.4953C6.43694 25.36 8.81271 26.6299 11.3991 27.1444C13.9855 27.6588 16.6664 27.3948 19.1028 26.3856C21.5391 25.3764 23.6215 23.6675 25.0866 21.4748C26.5517 19.2822 27.3337 16.7043 27.3337 14.0672C27.3301 10.5321 25.9242 7.14275 23.4245 4.64303C20.9248 2.14331 17.5355 0.737417 14.0003 0.733887ZM21.919 11.0179V11.8792C21.919 11.9451 21.9058 12.0104 21.8802 12.0711C21.8546 12.1319 21.8171 12.1869 21.7698 12.2329C21.7226 12.2788 21.6666 12.3149 21.6052 12.3389C21.5438 12.3629 21.4782 12.3743 21.4123 12.3726C20.0046 12.2728 18.6579 11.7588 17.5417 10.8952V17.1992C17.5415 17.8969 17.4023 18.5876 17.1321 19.2309C16.862 19.8742 16.4664 20.4572 15.9683 20.9459C15.4658 21.4467 14.8687 21.8426 14.2118 22.1104C13.5548 22.3783 12.8511 22.5127 12.1417 22.5059C10.7149 22.5034 9.34557 21.9436 8.32566 20.9459C7.67685 20.2918 7.20952 19.48 6.96966 18.5904C6.72979 17.7009 6.72566 16.7642 6.95766 15.8726C7.16966 15.0166 7.59766 14.2299 8.20166 13.5886C8.6521 13.038 9.2199 12.5951 9.86352 12.2922C10.5071 11.9893 11.2103 11.8341 11.9217 11.8379H13.015V14.1086C13.0155 14.1745 13.0019 14.2398 12.9752 14.3001C12.9484 14.3604 12.9091 14.4142 12.8599 14.4582C12.8107 14.5021 12.7527 14.535 12.6898 14.5547C12.6269 14.5744 12.5605 14.5805 12.495 14.5726C11.8602 14.3819 11.1761 14.4451 10.587 14.749C9.99796 15.0528 9.54985 15.5735 9.33719 16.2013C9.12453 16.8291 9.16392 17.5149 9.44707 18.1142C9.73021 18.7135 10.235 19.1795 10.855 19.4139C11.215 19.6206 11.6177 19.7419 12.031 19.7699C12.351 19.7832 12.671 19.7432 12.975 19.6472C13.4827 19.4763 13.9244 19.1511 14.2382 18.717C14.5521 18.2829 14.7225 17.7616 14.7257 17.2259V5.73922C14.7255 5.67625 14.7377 5.61386 14.7617 5.55563C14.7857 5.4974 14.8209 5.44448 14.8654 5.39989C14.9099 5.3553 14.9627 5.31992 15.0208 5.29578C15.079 5.27164 15.1414 5.25922 15.2043 5.25922H17.091C17.2137 5.25905 17.3317 5.30599 17.4208 5.39035C17.5099 5.4747 17.5632 5.59004 17.5697 5.71255C17.6387 6.3008 17.8256 6.86908 18.1193 7.3834C18.413 7.89773 18.8074 8.34752 19.279 8.70589C19.9165 9.18441 20.6736 9.47783 21.467 9.55389C21.5858 9.56405 21.697 9.61693 21.7798 9.70272C21.8627 9.78852 21.9117 9.90143 21.9177 10.0206L21.919 11.0179Z"
                fill="#FAFAFA"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="item__footer info_pages_mob">
      <div class="info_pages">
        <router-link to="terms-and-conditions" class="text_m"
          >Terms & Conditions</router-link
        >
        <router-link to="privacy-policy" class="text_m"
          >Privacy Policy</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import LogoToFooter from '@/components/svg/LogoToFooter.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Footer',
  components: { LogoToFooter },
};
</script>

<style scoped lang="scss">
.section_footer {
  background: #131313;
  width: 100%;
  box-sizing: border-box;
  padding: 46px 120px;
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
}
.info_pages {
  display: flex;
  gap: 20px;
}
.text_m {
  line-height: 16.94px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
}
.box_logo__footer {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-right: 56px;
}
.text_footer {
  font-size: 20px;
  line-height: 24.2px;
  font-weight: 500;
  color: #ffffff;
}
.item__footer {
  display: flex;
}
.item__footer_btn {
  padding: 0px 56px;
  border-left: 1px solid #302f2f;
  border-right: 1px solid #302f2f;
}
.are_venue {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
  gap: 25px;
  border-right: 0px solid #302f2f;
}
.icons_social {
  display: flex;
  gap: 34.6px;
}
.follow-us-on {
  font-size: 20px;
  line-height: 24.2px;
  font-weight: 500;
  color: #ffffff;
}
.box__follow-us-on {
  display: flex;
  flex-direction: column;
  padding-left: 56px;
  box-sizing: border-box;
  gap: 16px;
}
.box_any_questions {
  width: 277px;
  gap: 25px;
  display: flex;
  flex-direction: column;
}
.info_pages_mob {
  display: none;
}
.info_pages_desc {
  display: flex;
}
@media (max-width: 992px) {
  .section_footer {
    padding: 46px 39px;
    flex-direction: column;
  }
  .item__footer {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .box_logo__footer {
    padding: 0;
    align-items: center;
  }
  .item__footer_btn.are_venue {
    width: 100%;
  }
  .item__footer_btn.box_any_questions {
    width: 100%;
  }
  .are_venue {
    gap: unset;
  }
  .are_venue,
  .box_any_questions {
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .box__follow-us-on {
    padding: 0;
    display: flex;
    justify-content: center;
  }
  .follow-us-on {
    text-align: center;
  }
  .info_pages_mob {
    display: flex;
  }
  .info_pages_desc {
    display: none;
  }
  .section_footer {
    gap: 32px;
  }
}
@media (max-width: 768px) {
  .item__footer_res {
    flex-direction: column;
  }
  .item__footer_btn.are_venue {
    padding: 0;
    display: flex;
  }
  .item__footer_btn.box_any_questions {
    padding: 0;
    display: flex;
  }
  .are_venue,
  .box_any_questions {
    flex-direction: initial;
    border-top: 1px solid #302f2f;
    border-bottom: 1px solid #302f2f;
    border-left: 0px solid;
    border-right: 0px solid;
  }
  .section_footer {
    padding: 54px 20px;
    flex-direction: column;
  }
  .text_footer {
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
  }
  .logo_f {
    width: 108px;
    height: 40px;
  }
}
</style>
